.root {
    position: relative;
}

.controls {
    position: absolute;
    inset: 0 var(--labui-container-margin);
    display: flex;
    align-items: center;
    justify-content: space-between;
    pointer-events: none;
}

.arrow {
    pointer-events: auto;
    width: var(--spacer-40);
    height: var(--spacer-40);
    // optical adjustment for arrow SVG
    padding-left: 0.2em;
    border-radius: var(--border-radius-full);
    background: var(--overlay-off-white-80);
    backdrop-filter: blur(2px);
    box-shadow: 0 0 4px rgb(0 0 0 / 16%);
    display: flex;
    align-items: center;
    justify-content: center;
    fill: var(--black);
    transition: background 0.2s ease;

    &:hover {
        background: var(--white);
    }

    &[disabled] {
        visibility: hidden;
    }
}

.arrowPrev {
    composes: arrow;
    transform: scaleX(-1);
}

.arrowNext {
    composes: arrow;
}

.scrollContainer {
    visibility: inherit;
}

.arrowSvg {
    width: var(--spacer-24);
    height: var(--spacer-24);
}

.dots {
    --carousel-dot-width: var(--spacer-8);
    --carousel-dot-hitbox: var(--spacer-24);
    --carousel-dots-gap: calc(
        var(--spacer-16) - var(--carousel-dot-hitbox) +
            var(--carousel-dot-width)
    );
    --carousel-dot-color: var(--dot-color);
    --carousel-dot-active-color: var(--dot-active-color);
    --carousel-dot-stroke: var(--dot-stroke);

    position: absolute;
    bottom: var(--spacer-32);
    left: 50%;
    display: flex;
    gap: var(--carousel-dots-gap);
    transform: translateX(-50%);
    z-index: 1;

    & > * {
        display: block;
        padding: calc(
            (var(--carousel-dot-hitbox) - var(--carousel-dot-width)) / 2
        );

        &::before {
            content: "";
            display: block;
            width: var(--carousel-dot-width);
            height: var(--carousel-dot-width);
            border-radius: var(--carousel-dot-width);
            box-shadow: 0 0 0 1px var(--carousel-dot-stroke);
            background: var(--carousel-dot-color);
            transition: width 0.2s ease;
        }

        &[data-active]::before {
            width: var(--spacer-24);
            background: linear-gradient(
                to right,
                var(--carousel-dot-active-color)
                    calc(var(--autoplay-progress, 1) * 100%),
                var(--dot-overlay) calc(var(--autoplay-progress, 1) * 100%)
            );
        }
    }
}
